import { render, staticRenderFns } from "./ArtefactSection.vue?vue&type=template&id=1ea03ecb&"
import script from "./ArtefactSection.vue?vue&type=script&lang=js&"
export * from "./ArtefactSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports